<div [class.oculto]="modalPedidoOrigenSrv.ocultarModal"
     class="fondo-modal-imagen ">

    <div class="modal fade show"
         id="exampleModal"
         tabindex="-1"
         role="dialog"
         aria-labelledby="exampleModalLabel1"
         style="display: block;"
         (click)="cerrarModalClickOutside($event)">

        <div class="modal-dialog modal-lg"
             role="document">

            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title"
                        id="exampleModalLabel1">
                        <i class="fa-solid fa-receipt"></i> Datos del origen del pedido {{modalPedidoOrigenSrv.pedido?.pedido_cli }}
                    </h4>
                    <button type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close">
                        <span (click)="cerrarModal()"
                              aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body bg-light">

                    <!-- Contenido del pedido -->
                    <div *ngIf="!modalPedidoOrigenSrv.loading">

                        <div *ngIf="modalPedidoOrigenSrv.pedido?.pedidoExterno; else sinDatos">

                            <!-- Sección: Información General -->
                            <div class="card shadow-sm border-0 mb-3 rounded-3">
                                <div class="card-header bg-white border-0 py-3">
                                    <h5 class="mb-0 text-primary d-flex align-items-center">
                                        <i class="fa-solid fa-circle-info me-2 mr-2"></i> Información del Registro Origen
                                    </h5>
                                </div>
                                <div class="card-body pt-0">
                                    <div class="row text-center align-items-center">
                                        <div class="col-md-4 border-right border-end">
                                            <p class="mb-1 text-muted small">ID Origen</p>
                                            <p class="h5   mb-0">#{{ modalPedidoOrigenSrv.pedido.pedidoExterno.id }}</p>
                                        </div>
                                        <div class="col-md-4 border-right border-end">
                                            <p class="mb-1 text-muted small">Origen</p>
                                            <div [innerHTML]="modalPedidoOrigenSrv.pedido.pedidoExterno.tipo | pedidoExternoTipo"></div>
                                        </div>
                                        <div class="col-md-4">
                                            <p class="mb-1 text-muted small">Referencia</p>
                                            <div [innerHTML]="modalPedidoOrigenSrv.pedido.pedidoExterno.ref_envio || 'N/A'"></div>
                                        </div>
                                    </div>

                                    <!-- Información del Fichero de Origen -->
                                    <div class="row mt-3 p-3 bg-light rounded-3 mx-1 border border-info border-opacity-25"
                                         *ngIf="modalPedidoOrigenSrv.pedido.pedidoExterno.origen">
                                        <div class="col-md-8">
                                            <p class="mb-1 text-muted small">Fichero de Importación</p>
                                            <p class="mb-0 text-primary font-weight-bold">
                                                <i class="fa-solid fa-file-csv me-1 mr-1"></i>
                                                {{ modalPedidoOrigenSrv.pedido.pedidoExterno.origen }}
                                            </p>
                                        </div>
                                        <div class="col-md-2 text-center border-right border-end">
                                            <p class="mb-1 text-muted small">Línea</p>
                                            <p class="mb-0 badge bg-dark text-white">{{ modalPedidoOrigenSrv.pedido.pedidoExterno.origen_linea || 'N/A' }}</p>
                                        </div>
                                        <div class="col-md-2 text-center">
                                            <p class="mb-1 text-muted small">Acción</p>
                                            <a [href]="dataDir + '/import/pedidosExternos/' + modalPedidoOrigenSrv.pedido.pedidoExterno.origen"
                                               target="_blank"
                                               class="btn btn-xs btn-outline-primary py-0 px-2"
                                               title="Descargar fichero fuente">
                                                <i class="fa-solid fa-download"></i>
                                            </a>
                                        </div>
                                    </div>

                                    <hr class="my-3 opacity-10">
                                    <div class="row">
                                        <div class="col-md-6 mb-2">
                                            <p class="mb-1 text-muted small">Fecha Pedido Origen</p>
                                            <p class="mb-0 small"><i class="fa-regular fa-calendar-check me-1 mr-1 text-primary"></i> {{ modalPedidoOrigenSrv.pedido.pedidoExterno.fecha_pedido | date:'dd/MM/yyyy HH:mm' }}</p>
                                        </div>
                                        <div class="col-md-6 mb-2 text-md-right text-md-end">
                                            <p class="mb-1 text-muted small">Fecha Carga Sistema</p>
                                            <p class="mb-0 small"><i class="fa-solid fa-cloud-arrow-up me-1 mr-1 text-success"></i> {{ modalPedidoOrigenSrv.pedido.pedidoExterno.fecha_carga | date:'dd/MM/yyyy HH:mm' }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Sección: Datos del Destinatario -->
                            <div class="card shadow-sm border-0 mb-3 rounded-3">
                                <div class="card-header bg-white border-0 py-3">
                                    <h5 class="mb-0 text-success d-flex align-items-center">
                                        <i class="fa-solid fa-truck-fast me-2 mr-2"></i> Datos de Envío Originales
                                    </h5>
                                </div>
                                <div class="card-body pt-0">
                                    <div class="row">
                                        <div class="col-12 mb-3">
                                            <p class="mb-1 text-muted small">Nombre / Razón Social</p>
                                            <p class="h5 mb-0 text-dark font-weight-bold">{{ modalPedidoOrigenSrv.pedido.pedidoExterno.nombre }}</p>
                                        </div>
                                        <div class="col-md-8">
                                            <p class="mb-1 text-muted small">Dirección Completa</p>
                                            <p class="mb-0">{{ modalPedidoOrigenSrv.pedido.pedidoExterno.direccion }}</p>
                                            <p class="mb-0">{{ modalPedidoOrigenSrv.pedido.pedidoExterno.cp }} - {{ modalPedidoOrigenSrv.pedido.pedidoExterno.poblacion }}</p>
                                            <p class="text-muted small"><i class="fa-solid fa-map-location-dot me-1 mr-1"></i> {{ modalPedidoOrigenSrv.pedido.pedidoExterno.provincia }} ({{ modalPedidoOrigenSrv.pedido.pedidoExterno.pais_iso }})</p>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="p-2 bg-light rounded text-center border">
                                                <p class="mb-1 text-muted small">Servicio</p>
                                                <p class="mb-0 font-weight-bold"> {{ modalPedidoOrigenSrv.pedido.pedidoExterno.cod_servicio || 'N/A' }}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <hr class="my-2 opacity-10">
                                    <div class="row mt-3">
                                        <div class="col-md-6 mb-2">
                                            <p class="mb-1 text-muted small">Email de Contacto</p>
                                            <p class="mb-0 small font-italic"><i class="fa-solid fa-envelope me-1 mr-1 text-muted"></i> {{ modalPedidoOrigenSrv.pedido.pedidoExterno.email || 'No facilitado' }}</p>
                                        </div>
                                        <div class="col-md-6 mb-2">
                                            <div class="row">
                                                <div class="col-6">
                                                    <p class="mb-1 text-muted small">Teléfono</p>
                                                    <p class="mb-0 small"><i class="fa-solid fa-phone me-1 mr-1 text-muted"></i> {{ modalPedidoOrigenSrv.pedido.pedidoExterno.telefono || 'No facilitado' }}</p>
                                                </div>
                                                <div class="col-6"
                                                     *ngIf="modalPedidoOrigenSrv.pedido.pedidoExterno.contrarrembolso != '0.00'">
                                                    <p class="mb-1 text-muted small text-danger font-weight-bold">Contrarrembolso</p>
                                                    <p class="mb-0 small text-danger font-weight-bold">
                                                        <i class="fa-solid fa-hand-holding-dollar me-1 mr-1"></i>
                                                        {{ modalPedidoOrigenSrv.pedido.pedidoExterno.contrarrembolso | number:'1.2-2' }} €
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <ng-template #sinDatos>
                            <div class="alert alert-info text-center shadow-sm rounded-3 py-5 bg-white">
                                <div class="mb-3">
                                    <i class="fa-solid fa-magnifying-glass fa-3x text-muted opacity-50"></i>
                                </div>
                                <h4 class="alert-heading text-dark">Sin datos detallados</h4>
                                <p class="text-muted">No se ha encontrado un registro paralelo en la tabla de pedidos externos para este pedido.</p>
                            </div>
                        </ng-template>

                        <div class="d-flex justify-content-end mt-4">
                            <button type="button"
                                    (click)="cerrarModal()"
                                    class="btn waves-effect waves-light btn-rounded btn-outline-secondary px-4"
                                    data-dismiss="modal">Cerrar</button>
                        </div>

                    </div>


                </div>
            </div>
        </div>
    </div>


</div>